<template>
  <div>
    <Banners mode="statisticsBanner" />
  </div>
</template>

<script>
import appConfig from '@/app.config'
import Banners from '../../../components/dadban/banners/Banners.vue'

export default {
  page: {
    title: 'مدیریت بنر آماری صفحه اصلی',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-statistics-banner',
  components: { Banners },
}
</script>
